/**
 * useSessionValidator.js
 * Hook que verifica cada 30 minutos si la sesión sigue siendo válida
 */

import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useSessionValidator = (shouldValidate = true) => {
    const navigate = useNavigate();

    const validateSession = useCallback(async () => {
        try {
            const token = localStorage.getItem('control_campo_token');

            if (!token) {
                console.log('No hay token, no se valida sesión');
                return;
            }

            // Hacer petición al backend para validar token
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/auth/validate-token`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (!response.ok) {
                // Token no válido
                console.warn('Token inválido detectado');

                // Limpiar localStorage
                localStorage.removeItem('control_campo_token');
                localStorage.removeItem('control_campo_user');
                localStorage.removeItem('technicianReport');

                // Mostrar alerta
                alert('Tu sesión ha expirado. Por favor inicia sesión nuevamente.');

                // Redirigir a login
                navigate('/login', { replace: true });
                return;
            }

            const data = await response.json();

            if (!data.valid) {
                // Token expirado o inválido
                console.warn('Token expirado o inválido');

                localStorage.removeItem('control_campo_token');
                localStorage.removeItem('control_campo_user');
                localStorage.removeItem('technicianReport');

                alert('Tu sesión ha expirado. Por favor inicia sesión nuevamente.');
                navigate('/login', { replace: true });
            }

        } catch (error) {
            console.error('Error validando sesión:', error);
            // No hacer logout si hay error de red
        }
    }, [navigate]);

    useEffect(() => {
        if (!shouldValidate) return;

        // Validar al montar
        validateSession();

        // Validar cada 30 minutos (1800000 ms)
        const interval = setInterval(validateSession, 1800000);

        return () => clearInterval(interval);
    }, [shouldValidate, validateSession]);

    return { validateSession };
};